var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.filterTemplate,_vm._b({tag:"component",on:{"selectCategory":_vm.selectCategory,"setSearchQuery":_vm.setSearchQuery}},'component',_vm.componentProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }